import { render, staticRenderFns } from "./oui-cfhcoupon.vue?vue&type=template&id=65ad071c&scoped=true&"
import script from "./oui-cfhcoupon.vue?vue&type=script&lang=js&"
export * from "./oui-cfhcoupon.vue?vue&type=script&lang=js&"
import style0 from "./oui-cfhcoupon.vue?vue&type=style&index=0&id=65ad071c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad071c",
  null
  
)

export default component.exports